<template lang="pug">
  el-card(shadow="hover",v-if="processo.id").card-container
    .titulo-analise
      el-menu(default-active="1" mode="horizontal" @select="handleSelect")
          el-menu-item(index="1") Emissão do DAE {{processo.numeroProcesso}}
    template(
      v-if="step === 1"
    )
      el-steps.mt-20(:active='tela', finish-status='success', align-center, v-if="exibirSteps")
        el-step(
          title='Confirmar dados'
          status="process"
          icon="el-icon-tickets"
          v-if="confirmarDados"
        )
      div
        div
          el-divider
            h3 Dados do documento
          el-row(:gutter="40")
            el-col(:span="8")
              app-display(label="Nome/Razão Social:", :content="dadosInteressado.nomeRazaoSocial")
              app-display(label="CPF/CNPJ:", :content="dadosInteressado.cpfCnpj")
              app-display(label="Endereço:", :content="endereco")
              app-display(label="Município:", :content="municipio")
              app-display(label="Telefone:", :content="telefone")
            el-col(:span="8")
              app-display(label="Documento Origem:", :content="processo.numeroProcesso")
              app-display(label="Receita:", :content="receita")
              app-display(label="Referência:", :content="referencia")
              app-display(label="Data de Vencimento:", :content="formatData(dataVencimento)")
              app-display(label="Data do Cálculo:", :content="dataCalculo")
            el-col(:span="8")
              app-display(label="Valor Principal:", :content="formatValor(valorPrincipal)")
              app-display(label="Valor Correção Monetária:", :content="formatValor(valorCorrecao)")
              app-display(label="Valor Acréscimos Monetários:", :content="formatValor(valorAcrescimo)")
              app-display(label="Valor Multa:", :content="formatValor(valorMulta)")
              app-display(label="Valor Total:", :content="formatValor(valorTotal)")
      app-buttons-cadastro(
        :isUltimoPasso="true"
        @cancelar='cancelar',
        @voltar='voltar',
        @finalizar='finaliza',
        :showButtonCancelar='showButton',
        :showButtonProximo='showButton',
      )
    template(
      v-if="dadosCadastro"
    )
      el-card(shadow="hover").card-collapse
        app-despachos(
          :idProcesso="idProcesso",
          :data="dadosCadastro.setores",
          @getDownload="getDownload",
          @getAnotacao="getAnotacao"
        )
</template>

<script>
import FileSaver from 'file-saver'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppDoubleInput from '@/components/AppDoubleInput'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import AppOpcoesHeaderAnalise from './components//modal/AppOpcoesHeaderAnalise'
import AppPagamento from '@/components/AppPagamentoGestaoVtn'
import AppPagamentoMa from '@/components/AppPagamentoMa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDespachos from '@/components/AppDespachos'
import axios from '@/utils/api'

export default {
  components: {
    AppLabel,
    AppDivider,
    AppDisplay,
    AppButtonsCadastro,
    AppDoubleInput,
    AppOpcoesHeaderAnalise,
    AppPagamento,
    AppPagamentoMa,
    AppDespachos
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      tela: 1,
      formaPagamento: null,
      passo1: true,
      ultimoPasso: false,
      valorPrincipal: 0,
      valorCorrecao: 0,
      valorAcrescimo: 0,
      valorTotal: 0,
      valorTotalBoleto: 0,
      valorDesconto: 0,
      valorLiquido: 0,
      valorMulta: 0,
      parcelaSelecionada: null,
      dataEmissao: new Date(),
      dataVencimentoPreDefinida: null,
      dataVencimento: null,
      municipio: null,
      pegarMunicipio: null,
      municipios: null,
      endereco: '',
      telefone: '',
      idMunicipio: null,
      informacoesAdicionais: '',
      dadosInteressado: null,
      dadosCadastro: null,
      step: 1,
      processo: {
        numeroProcesso: null,
        numeroProtocolo: null
      },
      isEdicao: false,
      idBoletoEdicao: null,
      isVisualizarMunicipio: false,
      options: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      vtn: {},
      referencia: ''
    }
  },
  props: {
    idProcesso: {
      required: true
    },
    emitirDae: {
      required: false,
      default: true
    },
    confirmarDados: {
      required: false,
      default: true
    },
    parcela: {
      required: false
    }
  },
  async mounted () {
    const idProcesso = this.$route.params.idProcesso
    this.dadosInteressado = await this.processoPessoa(idProcesso)
    const processo = await this.getProcessoById(idProcesso)
    this.processo = processo
    this.municipios = await this.findByCodigoEstado(process.env.ESTADO.toUpperCase()) || []
    this.isVisualizarMunicipio = !!this.municipios.find(m => m.id === this.dadosInteressado.endereco.municipio.id)
    this.valorPrincipal = this.getAllProps(this.parcela.resumoDto, 'valor total')
    this.valorCorrecao = this.getAllProps(this.parcela.resumoDto, 'correção monetária')
    this.valorTotal = this.getAllProps(this.parcela.resumoDto, 'valor final')
    this.valorAcrescimo = this.getAllProps(this.parcela.resumoDto, 'juros')
    if (this.parcela.resumoDto.length > 3) {
      this.valorMulta = this.getAllProps(this.parcela.resumoDto, 'multa')
    }
    this.dataVencimento = this.getDataVencimentoPreDefinida()
    this.utilizarEndereco()
    this.utilizarTelefone()
    this.utilizarMunicipio()
    this.vtn = await this.getVtn(idProcesso)
    this.referencia = `${this.receita} ${this.getReceita()}`
  },
  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    }),
    exibirSteps () {
      return true
    },
    dataCalculo () {
      return moment(new Date()).format('DD/MM/YYYY')
    },
    isPrimeiroPasso () {
      if (this.visualizarDae) {
        return false
      } else if (this.tela === 1) {
        return true
      }
      return false
    },
    receita () {
      return this.parcela?.receita?.tipoReceita?.descricao || 'RECEITA DE VALOR DA TERRA NUA-VTN/ITERPA 5803-3'
    },
    isParcelado () {
      return this.formaPagamento === 'PARCELADO'
    },
    parcelas () {
      return [2, 3, 4, 5]
    },
    exibirTabelaParcelas () {
      return this.isParcelado && this.parcelaSelecionada && this.valorPrincipal !== 0
    },
    showButton () {
      return !this.visualizarDae
    }
  },

  methods: {
    ...mapActions({
      getProcessoById: 'processo/getProcessoById',
      finalizar: 'analiseDae/finalisar',
      emitirDaePorParcela: 'dae/emitirDaePorParcelaDoVtn',
      getMultaJuros: 'dae/jurosDae',
      getBoletosByProcesso: 'dae/getBoletosByProcesso',
      findByCodigoEstado: 'dae/findByCodigoEstado',
      processoPessoa: 'dae/processoPessoa',
      iniciaAnalise: 'processo/iniciaAnalise',
      reemitirDae: 'dae/reemitirDae',
      updateDae: 'dae/updateDae',
      getValorBoleto: 'dae/getValorBoleto',
      getVtn: 'vtn/getVtnProcessoId',
      getParcelas: 'vtn/getParcelas',
      emitir: 'dae/emitirDae'
    }),
    /**
     * Retorna 0 caso não encontre o valor do resumoDTO, e se encontrar retorna o valor
     * @param {*} item é um array do resumoDTO
     * @param {*} search é o nome da descrição do objeto
     */
    getAllProps (item = [], search) {
      if (item.filter(resumo => resumo.descricao.toLowerCase().includes(search)).length > 0) {
        return item.filter(resumo => resumo.descricao.toLowerCase().includes(search))[0].valor
      }
      return 0
    },
    setRadio (tipo) {
      this.formaPagamento = tipo
      this.valorDesconto = 0
      this.parcelaSelecionada = null
    },
    getDataVencimentoPreDefinida () {
      const date = new Date()
      this.dataVencimentoPreDefinida = new Date()
      return this.dataVencimentoPreDefinida.setDate(date.getDate() + 30)
    },
    setDataVencimentoParcelas (index) {
      const date = new Date()
      var dataVencimentoParcela = new Date()
      dataVencimentoParcela.setFullYear(date.getFullYear() + index)
      return dataVencimentoParcela
    },
    pegaNomeMunicipio () {
      this.municipio = this.municipios.find(municipio => municipio.id === this.idMunicipio)?.nome || '-'
    },
    async handleSelect (index) {
      if (parseInt(index) === this.step) {
        return
      }
      if (this.step === 1) {
        this.step = 2
        this.dadosCadastro = await this.iniciaAnalise({idProcesso: this.idProcesso, tipoAcao: 'DAE'})
      } else {
        this.step = 1
        this.dadosCadastro = null
      }
    },
    async utilizarEndereco () {
      this.endereco = `${this.dadosInteressado?.endereco?.logradouro}, ${this.dadosInteressado?.endereco?.numero ? this.dadosInteressado?.endereco?.numero : 'sem número'}, ${this.dadosInteressado?.endereco?.complemento ? (this.dadosInteressado?.endereco?.complemento + ',') : ''} ${this.dadosInteressado?.endereco?.bairro}`
    },
    async utilizarTelefone () {
      this.telefone = this.dadosInteressado.telefones[0].numero
    },
    utilizarMunicipio () {
      this.idMunicipio = this.dadosInteressado?.endereco?.municipio?.id
      this.pegaNomeMunicipio()
    },
    cancelar () {
      this.$router.back()
    },
    async proximo () {
      this.tela++
      this.passo1 = false
    },
    voltar () {
      this.$router.back()
    },
    formatValor (valor) {
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    getReceita () {
      let text = ''
      this.parcela.parcelasVtn.forEach((p, index) => {
        text += `${p?.numeroParcela}º`
        if (index < this.parcela.parcelasVtn.length - 1) {
          text += ', '
        }
      })
      return `Referente as parcela(s) ${text}`
    },
    formatData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    finaliza () {
      this.confirmBox(this.$messages.CONFIRMAR_BOLETO,
        this.$messages.TITULO_WARNING,
        async () => {
          const parcelas = this.parcela.parcelasVtn
          let parcelaNumero = this.parcela.parcelasVtn[0].numeroParcela
          parcelas.forEach(p => {
            if (p.numeroParcela < parcelaNumero) {
              parcelaNumero = p.numeroParcela
            }
          })
          const parcelaVtn = parcelas.find(p => p.numeroParcela === parcelaNumero)
          await axios({
            method: 'POST',
            url: `financeiro/emitirDaePorParcelaDoVtn?isVencida=true`,
            data: {
              id: parcelaVtn.id,
              idsParcelas: this.parcela.parcelasVtn.map(p => p.id)
            }
          }).then(() => {
            this.$router.back()
          })
        },
        () => {})
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    getDataVencimento () {
      const dataAtual = moment()
      const dataVencimento = dataAtual.add(30, 'days')

      return dataVencimento.format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped lang="scss">
.medium-margin-top {
  margin-top: 20px;
}

.small-margin-top {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.margin-btn {
  width: 16px;
  height: 25px;
  margin-bottom: 20px;
}

.justify {
  justify-content: space-between;
}

.btn {
  padding: 8px;
  margin-top: 1vh;
}

.disabled {
  background-color: #f5f7fa;
  color: #c8c5d3;
  cursor: not-allowed;
}

.full-width {
  width: -webkit-fill-available;
}

.mt-20 {
  margin-top: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-40 {
  margin-bottom: 40px;
}
.el-input__prefix {
  margin-top: 12px;
}

.link {
  cursor: pointer;
  color: #009f61;
  &:hover {
    font-weight: bold;
  }
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-analise {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: solid 1px #e6e6e6;
}

>>> .el-table__row {
  &:last-child {
    font-weight: bold;
  }
}

.select-erro {
  border: 1px solid #b22222;
  border-radius: 4px;
  border-color: #b22222;
  -webkit-box-shadow: inset 0 1px 2px #ff867c, 0 0 9px #b22222;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/EmitirDaeAnteciparParcela.vue